import { createFileRoute } from "@tanstack/react-router"
import { LiveEventsList } from "@/features/live-events-admin/LiveEventsList"

export const Route = createFileRoute("/live-events/")({
	component: LiveEventsList,
})
